
import { useState, useEffect } from "react";
import { collectOptionsSources } from "../../../../utils/deals/dealFormStepHelpers";
import { getOptionsBySource } from "../../../../services/api";
import { normalizeApiOptions } from "../dealFormFields";
import { StepDefinition } from "../../../../types/types";

export function useOptionsBySource(rawTemplateSteps: StepDefinition[]) {
  const sources = new Set<string>();
  rawTemplateSteps.forEach((step) => {
    collectOptionsSources(step?.fields || [], sources);
  });
  const sourcesKey = Array.from(sources).join(",");

  const [optionsBySource, setOptionsBySource] = useState<
    Record<string, Array<{ key: string; label: string }>>
  >({});
  const [loadingOptionsBySource, setLoadingOptionsBySource] = useState<
    Record<string, boolean>
  >({});

  useEffect(() => {
    if (!sourcesKey) return;
    const optionsSources = sourcesKey.split(",");

    let cancelled = false;

    optionsSources.forEach(async (source) => {
      setLoadingOptionsBySource((prev) => ({ ...prev, [source]: true }));

      try {
        const values = await getOptionsBySource(`/${source}`);
        if (cancelled) return;

        setOptionsBySource((prev) => ({
          ...prev,
          [source]: normalizeApiOptions(values),
        }));
      } catch {
        if (!cancelled) {
          setOptionsBySource((prev) => ({ ...prev, [source]: [] }));
        }
      } finally {
        if (!cancelled) {
          setLoadingOptionsBySource((prev) => ({
            ...prev,
            [source]: false,
          }));
        }
      }
    });

    return () => {
      cancelled = true;
    };
  }, [sourcesKey]);

  return { optionsBySource, loadingOptionsBySource };
}
